import * as React from "react"

import { HairNormal } from "./normal"
import { HairThick } from "./thick"
import { HairMohawk } from "./mohawk"
import { HairWomanLong } from "./womanLong"
import { HairWomanShort } from "./womanShort"

const _Hair = ({
  style,
  color,
  /* colorRandom, */
  isEditor
}: {
  style: string
  color: string
  /* colorRandom: boolean */
  isEditor?: boolean
}) => {
  switch (style) {
    case "thick":
      return (
        <HairThick
          isEditor={isEditor}
          color={color}
          /* colorRandom={colorRandom} */
        />
      )
    case "mohawk":
      return (
        <HairMohawk
          isEditor={isEditor}
          color={color}
          /*  colorRandom={colorRandom} */
        />
      )
    case "womanLong":
      return <HairWomanLong isEditor={isEditor} color={color} />
    case "womanShort":
      return <HairWomanShort isEditor={isEditor} color={color} />
    case "normal":
    default:
      return <HairNormal isEditor={isEditor} color={color} />
  }
}

export const Hair = React.memo(_Hair)
